<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Restant persoonsgebonden aftrek uit voorgaande jaren
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het restant van je aftrek van uitgaven die je vóór {{ this.year }} hebt gedaan, is het bedrag dat je
                niet eerder kon verrekenen met je inkomen over die jaren in respectievelijk box 1, 3 of 2.
                <div class="space10"></div>

                Je hebt alleen een restant van je aftrek van uitgaven die je vóór {{ this.year }} hebt gedaan als u:
                <li class="list">in je aangifte over 2022 of een eerder jaar gebruik hebt gemaakt van de
                    persoonsgebonden aftrek
                </li>
                <li class="list">toen nog persoonsgebonden aftrek over had, nadat je je inkomen uit werk en woning (box
                    1), je voordeel uit sparen en beleggen (box 3) en je voordeel uit aanmerkelijk belang (box 2) had
                    verminderd met je persoonsgebonden aftrek
                </li>
                <div class="space10"></div>

                In dat geval kun je het restant persoonsgebonden aftrek aftrekken in je aangifte {{ this.year }}.
                <div class="space10"></div>
                Is er sprake van een fiscaal partner met een restant persoonsgebonden aftrek? Dan vul je hier ook dat
                bedrag in.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Waar vind ik de hoogte van mijn restant persoonsgebonden aftrek
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Dat staat op je definitieve aanslag over {{ this.year - 1 }} bij 'Restant persoonsgebonden aftrek'.
                Heb je nog geen definitieve aanslag over {{ this.year - 1 }} ontvangen? Dan kunt je het bedrag overnemen
                uit je aangifte over{{ this.year - 1 }}. Je vindt dit in het overzicht van de aangifte bij 'Nog te
                verrekenen persoonsgebonden aftrek in volgende jaren'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Aftrekbare uitgaven
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Welke uitgaven mag je misschien nog aftrekken?
                <li class="list">betaalde partneralimentatieBijdrage in de kosten van levensonderhoud van je ex-partner.
                    Een ex-partner kan een ex-echtgenoot zijn of iemand met wie je hebt samengewoond, maar ook een
                    echtgenoot van wie je duurzaam gescheiden leeft. en andere onderhoudsverplichtingen
                </li>
                <li class="list">zorgkosten</li>
                <li class="list">uitgaven voor het tijdelijk verblijf thuis van gehandicapten</li>
                <li class="list">studiekosten die niet zijn omgezet in een gift</li>
                <li class="list"> giften</li>
                Let op! Wat je in een eerder jaar hebt afgetrokken, mag je niet nogmaals aftrekken.
                <div class="space10"></div>


                <b>Aftrekbare uitgaven vergeten?</b><br/>
                Heb je in je aangifte over {{ this.year - 1 }} of een eerder jaar sommige uitgaven niet afgetrokken,
                terwijl je dat wel had kunnen doen? En wil je deze uitgaven alsnog aftrekken? Dan kun je bezwaar maken
                tegen je definitieve aanslag over {{ this.year - 1 }} of het eerdere jaar. Geef in het bezwaarschrift
                gemotiveerd aan welke uitgaven je alsnog wilt aftrekken.
                <div class="space10"></div>

                Let op! Aftrekbare uitgaven die je eerder niet hebt afgetrokken in je aangifte, mag je niet opvoeren als
                restant persoonsgebonden aftrek.

            </div>
        </div>
    </div>
</div>



